module.exports = __webpack_public_path__ + "static/media/achieved-black.7c757003.svg";